var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5488_8950",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5488_8950)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.36663 11.5166H8.73329V7.33324H7.36663V11.5166ZM8.00113 6.3499C8.22813 6.3499 8.41802 6.27485 8.57079 6.12474C8.72357 5.97451 8.79996 5.78846 8.79996 5.56657C8.79996 5.32268 8.72335 5.12563 8.57013 4.9754C8.41679 4.82507 8.22685 4.7499 8.00029 4.7499C7.76118 4.7499 7.56802 4.82507 7.42079 4.9754C7.27357 5.12563 7.19996 5.3199 7.19996 5.55824C7.19996 5.78712 7.27674 5.97629 7.43029 6.12574C7.58385 6.27518 7.77413 6.3499 8.00113 6.3499ZM8.00663 15.0832C7.01918 15.0832 6.09629 14.8995 5.23796 14.5319C4.37963 14.1642 3.62863 13.6586 2.98496 13.0149C2.34129 12.3712 1.83563 11.6206 1.46796 10.7629C1.1004 9.90524 0.916626 8.98224 0.916626 7.9939C0.916626 7.00546 1.1004 6.08162 1.46796 5.2224C1.83563 4.36329 2.3404 3.61435 2.98229 2.97557C3.62418 2.3369 4.37435 1.83129 5.23279 1.45874C6.09135 1.08618 7.01529 0.899902 8.00463 0.899902C8.99396 0.899902 9.9189 1.08574 10.7795 1.4574C11.6399 1.82918 12.3891 2.33368 13.027 2.9709C13.6648 3.60812 14.1698 4.3574 14.5418 5.21874C14.9139 6.08018 15.1 7.00574 15.1 7.9954C15.1 8.9844 14.9137 9.90801 14.5411 10.7662C14.1686 11.6245 13.663 12.3737 13.0243 13.0139C12.3855 13.6541 11.6365 14.1591 10.7771 14.5287C9.91768 14.8984 8.99418 15.0832 8.00663 15.0832Z",
    fill: "#D0213D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.c3aadcbbc297685e295ef19c66059812.svg";
export { ForwardRef as ReactComponent };